import { render, staticRenderFns } from "./errorTemplate.vue?vue&type=template&id=01e52c76&scoped=true&"
import script from "./errorTemplate.vue?vue&type=script&lang=js&"
export * from "./errorTemplate.vue?vue&type=script&lang=js&"
import style0 from "./errorTemplate.vue?vue&type=style&index=0&id=01e52c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e52c76",
  null
  
)

export default component.exports